var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"f204d0105159814478c0f4efca7e8fcc27e8e015"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["home-waste-web@clearabee"]={id:"f204d0105159814478c0f4efca7e8fcc27e8e015"};
      